import { useEffect } from 'react'
import { fetchDynamicFieldsByEntitySales } from 'src/actions/dynamicfield.actions'
import { useDispatch, useSelector } from 'react-redux'
import { selectEntitySalesFields } from 'src/selectors/dynamicFields.selector'
import { useDynamicFields } from 'src/components/CompanyDynamicFields/hook/useDynamicFields'

export const useSaleDynamicFields = (withValues?: DynamicFieldRequest[]) => {
  const dispatch = useDispatch()
  const entityFields = useSelector(selectEntitySalesFields)

  useEffect(() => {
    dispatch(fetchDynamicFieldsByEntitySales())
  }, [])

  return useDynamicFields(entityFields, withValues)
}
